var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.964,
    height: 48.029,
    viewBox: "0 0 226.964 48.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-3809.036 -7596.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48917",
    "data-name": "Path 48917",
    d: "M-92.058-35.778a2.437,2.437,0,0,1,2.747-2.613A2.791,2.791,0,0,1-86.5-36.448L-73.3-7.571C-71.422-2.412-68.541.8-62.243.8c6.968,0,10.385-3.953,10.385-9.916V-45.225h-7.973V-9.447A2.43,2.43,0,0,1-62.511-6.9a3.054,3.054,0,0,1-2.881-1.876l-13.2-28.877c-1.876-5.159-4.69-8.375-10.988-8.375-7.035,0-10.385,3.953-10.385,9.849V0h7.906Zm69.814-9.447c-13.132,0-20.435,7.5-20.435,22.713C-42.679-7.37-35.443,0-22.244,0h6.164C-2.881,0,4.355-7.37,4.355-22.512c0-15.209-7.3-22.713-20.435-22.713Zm6.164,7.906c8.71,0,12.462,4.422,12.462,14.74,0,10.385-3.752,14.673-12.462,14.673h-6.164c-8.777,0-12.529-4.288-12.529-14.606,0-10.385,3.819-14.807,12.529-14.807ZM6.834-45.225l15.142,40.2C23.651-.6,27.068.8,31.49.8,36.18.8,39.262-.8,40.937-5.025l15.946-40.2H48.106L33.7-8.844A2.205,2.205,0,0,1,31.49-7.3a2.154,2.154,0,0,1-2.211-1.541L15.544-45.225Zm70.35,8.844a2.285,2.285,0,0,1,2.278-1.541,2.154,2.154,0,0,1,2.211,1.541L95.408,0h8.777L88.909-40.2c-1.608-4.221-4.69-5.829-9.38-5.829-4.757,0-7.839,1.608-9.514,5.829L54.136,0h8.71Z",
    transform: "translate(3909 7643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1967",
    "data-name": "Ellipse 1967",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(4024 7633)",
    fill: "#dc2751"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.352105a4c07f5df5a619445c683dfaed.svg";
export { ForwardRef as ReactComponent };